import type { FC } from 'react'
import { H3 } from '../../compass-ui'
import BaseBottomDrawer from '../BaseBottomDrawer'
import Accordion, { type AccordionTabProps } from '../Accordion'

interface FAQBottomDrawerProps {
  open: boolean
  toggleDrawerOpen: (value: boolean) => void
  data: AccordionTabProps[]
  id: string
  labelledBy: string
  describedBy: string
}

const FAQBottomDrawer: FC<FAQBottomDrawerProps> = ({
  open,
  toggleDrawerOpen,
  id,
  labelledBy,
  describedBy,
  data,
}) => (
  <BaseBottomDrawer
    open={open}
    onOpen={() => toggleDrawerOpen(true)}
    onClose={() => toggleDrawerOpen(false)}
    aria-labelledby={labelledBy}
    aria-describedby={describedBy}
  >
    <div className="flex flex-col" id={id} data-testid={id}>
      <H3 className="mb-2">Frequently asked questions</H3>
      <Accordion tabInfo={data} />
    </div>
  </BaseBottomDrawer>
)

export default FAQBottomDrawer
